import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> Alerts <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>パネル内に表示させる用のアラート</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3),
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col-md-12 col-xl-6" }, [
        _createElementVNode("div", {
          id: "panel-1",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Basic "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Alerts")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert alert-primary",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Heads up!"),
                  _createTextVNode(" This alert needs your attention, but it's not super important. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-success",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Well Done!"),
                  _createTextVNode(" You successfully read this important alert message. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-danger",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Oh snap!"),
                  _createTextVNode(" Change a few things up and try submitting again. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-warning",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Holy guacamole!"),
                  _createTextVNode(" You should check in on some of those fields below. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-info",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Info!"),
                  _createTextVNode(" Alert for passing information to user. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-secondary",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Hello World!"),
                  _createTextVNode(" This is default alert message box. ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          id: "panel-2",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Dismissable "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Alerts")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert alert-primary alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, "×")
                  ]),
                  _createElementVNode("strong", null, "Heads up!"),
                  _createTextVNode(" This alert needs your attention, but it's not super important. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-success alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("strong", null, "Well Done!"),
                  _createTextVNode(" You successfully read this important alert message. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-danger alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-trash-alt" })
                    ])
                  ]),
                  _createElementVNode("strong", null, "Oh snap!"),
                  _createTextVNode(" Change a few things up and try submitting again. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-warning alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times-square" })
                    ])
                  ]),
                  _createElementVNode("strong", null, "Holy guacamole!"),
                  _createTextVNode(" You should check in on some of those fields below. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-info alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times-circle" })
                    ])
                  ]),
                  _createElementVNode("strong", null, "Info!"),
                  _createTextVNode(" Alert for passing information to user. ")
                ]),
                _createElementVNode("div", {
                  class: "alert alert-secondary alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-window-close" })
                    ])
                  ]),
                  _createElementVNode("strong", null, "Hello World!"),
                  _createTextVNode(" This is default alert message box. ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          id: "panel-3",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Large "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Alerts")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert alert-success alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-1" }, [
                      _createElementVNode("i", { class: "fal fa-sync fs-xl fa-spin" })
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h6 m-0 fw-700" }, "Task 55% Complete"),
                      _createElementVNode("div", { class: "progress mt-1 progress-xs" }, [
                        _createElementVNode("div", {
                          class: "progress-bar progress-bar-striped progress-bar-animated bg-success-600",
                          role: "progressbar",
                          style: {"width":"55%"},
                          "aria-valuenow": "55",
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert bg-success-500 alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-1" }, [
                      _createElementVNode("i", { class: "fal fa-check fs-xl" })
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h6 m-0 fw-700" }, "Task 100% Complete"),
                      _createElementVNode("div", { class: "progress mt-1 progress-xs" }, [
                        _createElementVNode("div", {
                          class: "progress-bar progress-bar-striped bg-warning-500",
                          role: "progressbar",
                          style: {"width":"100%"},
                          "aria-valuenow": "100",
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert border-info bg-transparent text-info fade show",
                  role: "alert"
                }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("i", { class: "fal fa-exclamation-triangle" })
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5 m-0 fw-700" }, "Compilation error occured! ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-info btn-pills btn-sm btn-w-m mr-1 waves-effect waves-themed"
                    }, " Repair "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger btn-pills btn-sm btn-w-m waves-effect waves-themed",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    }, " Dismiss ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert border-danger bg-transparent text-secondary fade show",
                  role: "alert"
                }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                        _createElementVNode("i", { class: "base-7 icon-stack-3x color-danger-900" }),
                        _createElementVNode("i", { class: "fal fa-times icon-stack-1x text-white" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5 color-danger-900" }, "This branch is out-of-date with the base branch ")
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-outline-danger btn-sm btn-w-m waves-effect waves-themed"
                    }, "Report")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert border-faded bg-transparent text-secondary fade show",
                  role: "alert"
                }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                        _createElementVNode("i", { class: "base-7 icon-stack-3x color-success-600" }),
                        _createElementVNode("i", { class: "fal fa-check icon-stack-1x text-white" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5 color-success-600" }, "All checks have passed!"),
                      _createElementVNode("br"),
                      _createTextVNode(" 2 successful checks ")
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-outline-success btn-sm btn-w-m waves-effect waves-themed"
                    }, "Review")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert bg-info-400 text-white fade show",
                  role: "alert"
                }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("i", { class: "fal fa-info-circle" })
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5" }, "This branch is out-of-date with the base branch"),
                      _createElementVNode("br"),
                      _createTextVNode(" Some pipes failed during build. ")
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-warning btn-pills btn-sm width-8 waves-effect waves-themed"
                    }, "Fix")
                  ])
                ]),
                _createElementVNode("div", { class: "alert bg-fusion-400 border-0 fade show" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("i", { class: "fal fa-shield-check text-warning" })
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5" }, "Download complete"),
                      _createElementVNode("br"),
                      _createTextVNode(" Install the latest version of SmartAdmin WebApp ")
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-warning btn-w-m fw-500 btn-sm waves-effect waves-themed",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    }, "Install")
                  ])
                ]),
                _createElementVNode("div", { class: "alert bg-warning-500 alert-dismissible fade show" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-sm" }, [
                        _createElementVNode("i", { class: "base-7 icon-stack-3x color-fusion-200" }),
                        _createElementVNode("i", { class: "base-7 icon-stack-2x color-fusion-500" }),
                        _createElementVNode("i", { class: "ni ni-graph icon-stack-1x text-white" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5" }, "Large Icon Stack"),
                      _createElementVNode("br"),
                      _createTextVNode(" Custom alert background with "),
                      _createElementVNode("strong", null, "large"),
                      _createTextVNode(" sized icon stack. ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "col-md-12 col-xl-6" }, [
        _createElementVNode("div", {
          id: "panel-4",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Alert "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Outline")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert border border-primary bg-transparent text-primary",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Heads up!"),
                  _createTextVNode(" This alert needs your attention, but it's not super important. ")
                ]),
                _createElementVNode("div", {
                  class: "alert border-success bg-transparent text-success",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Well Done!"),
                  _createTextVNode(" You successfully read this important alert message. ")
                ]),
                _createElementVNode("div", {
                  class: "alert border-danger bg-transparent text-danger",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Oh snap!"),
                  _createTextVNode(" Change a few things up and try submitting again. ")
                ]),
                _createElementVNode("div", {
                  class: "alert border-warning bg-transparent color-warning-900",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Holy guacamole!"),
                  _createTextVNode(" You should check in on some of those fields below. ")
                ]),
                _createElementVNode("div", {
                  class: "alert border-info bg-transparent text-info",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Info!"),
                  _createTextVNode(" Alert for passing information to user. ")
                ]),
                _createElementVNode("div", {
                  class: "alert border-secondary bg-transparent text-secondary",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Hello World!"),
                  _createTextVNode(" This is default alert message box. ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          id: "panel-5",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Alternative "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Backgrounds")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert bg-info-500",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Info!"),
                  _createTextVNode(" Alert for passing information to user. ")
                ]),
                _createElementVNode("div", {
                  class: "alert bg-primary-200 text-white",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Heads up!"),
                  _createTextVNode(" This alert needs your attention, but it's not super important. ")
                ]),
                _createElementVNode("div", {
                  class: "alert bg-danger-400 text-white",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Oh snap!"),
                  _createTextVNode(" Change a few things up and try submitting again. ")
                ]),
                _createElementVNode("div", {
                  class: "alert bg-fusion-200 text-white",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Hello World!"),
                  _createTextVNode(" This is default alert message box. ")
                ]),
                _createElementVNode("div", {
                  class: "alert bg-warning-700 text-white",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, "Holy guacamole!"),
                  _createTextVNode(" You should check in on some of those fields below. ")
                ]),
                _createElementVNode("div", {
                  class: "alert bg-success-400 text-white",
                  role: "alert"
                }, [
                  _createElementVNode("strong", null, " Well Done!"),
                  _createTextVNode(" You successfully read this important alert message. ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          id: "panel-6",
          class: "panel"
        }, [
          _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, [
              _createTextVNode(" Stack "),
              _createElementVNode("span", { class: "fw-300" }, [
                _createElementVNode("i", null, "Icon")
              ])
            ]),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel waves-effect waves-themed",
                "data-action": "panel-close",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Close"
              })
            ])
          ]),
          _createElementVNode("div", { class: "panel-container show" }, [
            _createElementVNode("div", { class: "panel-content" }, [
              _createElementVNode("div", { class: "demo-v-spacing" }, [
                _createElementVNode("div", {
                  class: "alert alert-primary alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-2" }, [
                      _createElementVNode("span", {
                        class: "icon-stack",
                        style: {"font-size":"22px"}
                      }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-primary-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-primary-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("strong", null, "Custom stack icon size! "),
                      _createTextVNode(" You can change the stack icon size with font-size style property. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert border-primary bg-transparent text-primary alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-2" }, [
                      _createElementVNode("span", {
                        class: "icon-stack",
                        style: {"font-size":"22px"}
                      }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-primary-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-primary-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("strong", null, "Custom stack icon size! "),
                      _createTextVNode(" You can change the stack icon size with font-size style property. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert alert-success alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-3" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-sm" }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-success-600" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-success-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h5 m-0 fw-700" }, "Small Icon Stack!"),
                      _createTextVNode(" Custom alert background with "),
                      _createElementVNode("strong", null, "small"),
                      _createTextVNode(" sized icon stack. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "alert alert-info alert-dismissible fade show",
                  role: "alert"
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-md" }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-info-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-info-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h4" }, "Medim Icon Stack"),
                      _createElementVNode("br"),
                      _createTextVNode(" Custom alert background with "),
                      _createElementVNode("strong", null, "medium"),
                      _createTextVNode(" sized icon stack. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "alert alert-warning alert-dismissible fade show" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-6" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-warning-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-warning-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1" }, [
                      _createElementVNode("span", { class: "h3" }, "Large Icon Stack"),
                      _createElementVNode("br"),
                      _createTextVNode(" Custom alert background with "),
                      _createElementVNode("strong", null, "large"),
                      _createTextVNode(" sized icon stack. ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "alert bg-danger-600 alert-dismissible fade show" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-8" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-xl" }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-danger-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-danger-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1 pl-1" }, [
                      _createElementVNode("span", { class: "h2" }, " Hold on there Sparky! "),
                      _createElementVNode("br"),
                      _createTextVNode(" Better fix those errors before you can complete this request ")
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "alert alert-danger alert-dismissible fade show" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "alert",
                    "aria-label": "Close"
                  }, [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ])
                  ]),
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "alert-icon width-8" }, [
                      _createElementVNode("span", { class: "icon-stack icon-stack-xl" }, [
                        _createElementVNode("i", { class: "base-2 icon-stack-3x color-danger-400" }),
                        _createElementVNode("i", { class: "base-10 text-white icon-stack-1x" }),
                        _createElementVNode("i", { class: "ni md-profile color-danger-800 icon-stack-2x" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex-1 pl-1" }, [
                      _createElementVNode("span", { class: "h2" }, " Hold on there Sparky! "),
                      _createElementVNode("br"),
                      _createTextVNode(" Better fix those errors before you can complete this request ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}